module.exports = __webpack_public_path__ + "img/money-bill-trend-up-solid.5ea4be2a.svg";